import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteParamsHandlerService {

  params: any = [];

  private routeChanged = new Subject<any>();
  routeChanged$ = this.routeChanged.asObservable();

  constructor(private router: Router) {

    this.router.events.subscribe(async (e: any) => {

      //Clean params when the redirect URL does not include params, if not they will appear in the breadcrumb
      if (e instanceof NavigationEnd) {

        //Params only exist in selected school and intervention components, so if the URL does not include those words, the params are cleaned
        let urlDifferentFromHomeSchool = !(e.url.indexOf("/home/school/") != -1);
        let urlDifferentFromIntervention = !(e.url.indexOf("/intervention/") != -1);

        if (urlDifferentFromHomeSchool && urlDifferentFromIntervention) {
          this.changeParams({});
        }
      }
    })
  }

  /**
 * Method executed from the component that detects changes in route params
 * @param params parameters in the route
 */
  changeParams(params: Object) {
    this.params = params;
    this.routeChanged.next(this.params);
  }
}
